<div class="ml-20px mt-20px">
  Basic

  <ui-select ngModel="lucy">
    <ui-option uiValue="jack" uiLabel="Jack"></ui-option>
    <ui-option uiValue="lucy" uiLabel="Lucy"></ui-option>
    <ui-option uiValue="disabled" uiLabel="Disabled" uiDisabled></ui-option>
  </ui-select>
  <ui-select ngModel="lucy" uiDisabled>
    <ui-option uiValue="lucy" uiLabel="Lucy"></ui-option>
  </ui-select>
  <ui-select ngModel="lucy" uiLoading>
    <ui-option uiValue="lucy" uiLabel="Lucy"></ui-option>
  </ui-select>
  <ui-select ngModel="lucy" uiAllowClear suiPlaceHolder="Choose">
    <ui-option uiValue="lucy" uiLabel="Lucy"></ui-option>
  </ui-select>
</div>

<h4 class="sp-mt-24">More usage examples can be found at : <a href="https://ng.ant.design/components/select/en" target="_blank">https://ng.ant.design/components/select/en</a></h4>
